import { render, staticRenderFns } from "./mortgage-overview.vue?vue&type=template&id=2cb4c9de"
import script from "./mortgage-overview.vue?vue&type=script&lang=ts"
export * from "./mortgage-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports